module.exports = __webpack_public_path__ + "img/frame-mobile.c3b05e5e.jpg";